const state = {
  /*********************  接口数据  **********************/
  //分配规则
  splitRule: {
    geoGroup: "CAMPAIGN",
    creativeGroup: "CAMPAIGN",
  },
  //创意组
  creativeGroups: null,
  // 广告组名称
  adGroupNameRule: "",
  // 广告系列
  draftCampaign: {
    advertiserId: "",
    advertiserName: "",
    campaignId: "",
    campaignNameRule: "",
    advertisingChannelSubType: "APP_CAMPAIGN",
    startDate: "",
    endDate: "",
    //选择的app
    promoteApp: {},
    targetings: [],
    bid: {},
  },
};

const actions = {};

const mutations = {
  // 设置广告系列
  set_ad_series_google: (state, data) => {
    for (let prop in data) {
      if (Object.prototype.hasOwnProperty.call(state.draftCampaign, prop)) {
        state.draftCampaign[prop] = data[prop];
      }
    }
  },

  // 设置广告组名称
  set_adGroup_nameRule_google: (state, data) => {
    state.adGroupNameRule = data;
  },
  //设置分配规则
  set_split_rule_google: (state, data) => {
    state.splitRule[data.key] = data.value;
  },
  //批量设置分配规则
  set_all_split_rule_google: (state, data) => {
    state.splitRule = data;
  },
  //广告创意-创意组
  set_creative_groups_google: (state, data) => {
    state.creativeGroups = data;
  },
  set_creative_groupName_google: (state, data) => {
    //修改创意组名称
    let { name, id } = data;
    let curGroup = state.creativeGroups.find((item) => item.itemId === id);
    if (curGroup) {
      curGroup.group_name = name;
    }
  },
};

export default {
  state,
  actions,
  mutations,
};
